var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeparatorWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1918 376",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#0f1a67;}.cls-4{clip-path:url(#clip-path-2);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-6.53 219.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,71.86V34.41C53.71,34.41,53.71,0,107.41,0s53.7,34.41,107.41,34.41S268.52,0,322.23,0s53.71,34.41,107.41,34.41S483.35,0,537.05,0s53.71,34.41,107.41,34.41S698.17,0,751.87,0s53.71,34.41,107.41,34.41S913,0,966.69,0s53.71,34.41,107.41,34.41S1127.81,0,1181.52,0s53.71,34.41,107.41,34.41V71.86Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-6.53 219.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M643.07,71.86V34.41C696.77,34.41,696.77,0,750.48,0s53.7,34.41,107.41,34.41S911.59,0,965.3,0s53.7,34.41,107.41,34.41S1126.41,0,1180.12,0s53.7,34.41,107.41,34.41S1341.23,0,1394.94,0s53.7,34.41,107.41,34.41S1556.05,0,1609.76,0s53.7,34.41,107.41,34.41S1770.88,0,1824.58,0,1878.29,34.41,1932,34.41V71.86Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 1274.93,
    height: 1079.29
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 643.07,
    width: 1274.93,
    height: 1079.29
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeparatorWave);
export default __webpack_public_path__ + "static/media/separator_wave.976c4cf9be25aa32e85a03e4a717dbd0.svg";
export { ForwardRef as ReactComponent };